import { Handle, Position, NodeProps } from '@xyflow/react';

export function EndNode({ selected }: NodeProps) {
  return (
    <div
      className="wt-rf-node wt-rf-node-end"
      data-selected={selected ? 'true' : 'false'}
      style={{ borderColor: '#374151', background: '#f3f4f6' }}
    >
      <Handle type="target" position={Position.Top} className="wt-rf-port" />
      <div className="wt-rf-node-head" style={{ color: '#374151' }}>
        <span className="wt-rf-node-dot" style={{ background: '#374151' }} />
        <span>Fim</span>
      </div>
    </div>
  );
}
